export default __webpack_public_path__ + "static/media/warning.68ab77f5.svg";